import { FC } from "react";

interface Props {
  items: {
    index: string;
    title: string;
    text?: string;
  }[];
}

export const List: FC<Props> = ({ items }) => {
  return (
    <ul className="pl-[2em]">
      {items.map((item) => {
        return (
          <li className="relative pl-[1.5em]" key={item.index}>
            <div className="absolute left-0">{item.index}</div>
            <div>{item.title}</div>
            {item.text && <p className="indent-[1em]">{item.text}</p>}
          </li>
        );
      })}
    </ul>
  );
};
